import React, { useState } from 'react';

function FAQSection() {
  const [activeIndex, setActiveIndex] = useState(2);

  const faqIconStyles = `
    .faq-one-accrodion .accrodion-title h4::before {
      font-family: "Font Awesome 5 Free", "Font Awesome 6 Free";
      font-weight: 900;
      font-size: 14px;
      line-height: 16px;
      width: 22px;
      height: 22px;
    }
  `;

  const faqItems = [
    {
      question: 'Who can join the platform?',
      content: (
        <p>
          Verified professionals working in <b>Mental Health - Counselling
            Psychologist, Clinical Psychologist, Psychiatrists, Rehabilitation
            Psychologist, Neuropsychologist, Special Educator, Occupational
            Therapist, Speech Therapist, Sports Psychologist, Career Counsellors,
            Health Psychologist, Industrial Psychologist, Couples Counsellor,</b>{' '}
          etc. Our focus is multidisciplinary, so families can find holistic
          mental health care in one place.
        </p>
      )
    },
    {
      question: 'How is this different from other therapy platforms?',
      content: (
        <p>
          Unlike commission-based platforms, you keep <b>100% of your earnings.</b>{' '}
          You&apos;ll get a place to be discovered, plus, you get built-in tools
          - session notes, product sale space, workshop listing space,
          invoicing, blogging space, automated whatsapp reminders, calendar
          sync and so much more that helps you manage your private practice
          like never before.
        </p>
      )
    },
    {
      question: 'Is it free to join?',
      content: (
        <p>
          Yes! You can join a <b>Free profile listing</b> to get discovered by
          users. And you can also upgrade to <b>Pro</b> to unlock advanced
          tools, more accessibility and management with enhanced presence.
        </p>
      )
    },
    {
      question: 'How do I find a professional?',
      content: (
        <p>
          Use the <b>search filters</b> to browse by issue, services, age
          group, language, price, or location. You can view detailed profiles,
          introductions, and verified credentials.
        </p>
      )
    },
    {
      question: 'What benefits do I get as a client on PsychMitra?',
      content: (
        <>
          <p>
            With PsychMitra, taking care of your mental health becomes simple,
            affordable, and empowering. Here&apos;s how we make it better for you:
          </p>
          <ul style={{ marginLeft: '20px' }}>
            <li>
              <b>No inflated fees</b> - We don&apos;t charge commissions from
              practitioners, so you get honest, transparent session prices.
            </li>
            <li>
              <b>All experts, one platform</b> - Connect with all kinds of
              verified psychologists, psychiatrists, therapists, and special
              educators, and more, all in one place.
            </li>
            <li>
              <b>A safe space to express</b> - Share your thoughts, post memes,
              and engage in open conversations on our dedicated community posting
              wall.
            </li>
            <li>
              <b>Self-help tools that support you</b> - Explore a wide range of
              resources to help you cope, reflect, and grow anytime you need.
            </li>
            <li>
              <b>Smart session reminders</b> - Get automatic notifications 24
              hours and 1 hour before your session, so you never miss an
              appointment.
            </li>
            <li>
              <b>Zero subscriptions or hidden costs</b> - Pay only a minimal
              Rs29 convenience fee per booking, no extra charges.
            </li>
            <li>
              <b>Learn and grow</b> - Read insightful blogs from experts and
              attend workshops or seminars to deepen your understanding of mental
              health.
            </li>
          </ul>
          <p>
            PsychMitra isn&apos;t just a platform - it&apos;s your personal mental
            wellness companion, designed to help you heal, learn, and thrive.
          </p>
        </>
      )
    }
  ];

  return (
    <section className="faq-one">
      <style>{faqIconStyles}</style>
      <div
        className="faq-one__bg"
        style={{ backgroundImage: 'url(/assets/images/backgrounds/faq-one-bg.png)' }}
      ></div>
      <div className="container">
        <div className="row">
          <div className="col-xl-6">
            <div className="faq-one__left">
              <div className="section-title text-left">
                <span className="section-title__tagline">FAQ&apos;s</span>
                <h2 className="section-title__title">
                  Frequently Asked<span>Questions</span>
                </h2>
              </div>
              <div className="faq-one__img-and-points">
                <div className="faq-one__img" style={{ textAlign: 'center' }}>
                  <img
                    src="/assets/images/mascot/faq_homepg.jpeg"
                    alt="PsychMitra FAQ Mascot"
                    style={{
                      maxWidth: '100%',
                      height: 'auto',
                      borderRadius: '24px',
                      boxShadow: '0 15px 35px rgba(124, 75, 185, 0.14)'
                    }}
                  />
                </div>
              </div>
            </div>
          </div>
          <div className="col-xl-6">
            <div className="faq-one__right">
              <div className="accrodion-grp faq-one-accrodion" data-grp-name="faq-one-accrodion">
                {faqItems.map((item, index) => {
                  const isActive = index === activeIndex;

                  return (
                    <div key={item.question} className={`accrodion${isActive ? ' active' : ''}`}>
                      <div
                        className="accrodion-title"
                        onClick={() => {
                          if (!isActive) {
                            setActiveIndex(index);
                          }
                        }}
                      >
                        <h4>{item.question}</h4>
                      </div>
                      <div
                        className="accrodion-content"
                        style={{ display: isActive ? 'block' : 'none' }}
                      >
                        <div className="inner">{item.content}</div>
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
            <br />
            <div className="cta-one__btn-box">
              <a href="/faq" className="cta-one__btn thm-btn">
                View All FAQs
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default FAQSection;
